import {
  DataGrid,
  DataGridActions,
  DataGridColumns,
  DataGridSections,
  DataGridSelectedActions,
} from '@components/DataGrid/DataGrid'
import { DataGridPerson } from '@components/DataGrid/DataGridPerson'
import ExampleUser from '@assets/exampleUser.png'
import { DataGridList } from '@components/DataGrid/DataGridList'
import { randomBool } from '@utils/randomBool'
import { useLocation, useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { ActionIcon, Anchor, Box, Button, Menu, Text } from '@mantine/core'
import classes from '@styles/record.module.css'
import { IconChevronDown, IconDots } from '@tabler/icons-react'
import { randomArrayItem } from '@utils/randomArrayItem'

export const LinkedRecords = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleNavigate = () =>
    navigate(
      `../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`,
      location?.state?.history ? { state: location?.state } : {},
    )

  const data = Array(30)
    .fill(0)
    .map((_, i) => ({
      id: `invite-${i}`,
      name: (
        <DataGridPerson
          name="Alfredo Carrillo"
          image={ExampleUser}
          status="online"
          onClick={handleNavigate}
        />
      ),
      tags: <DataGridList title="Tags" data={['Some', 'Another', 'Another']} />,
      relationship: randomArrayItem([
        'Son',
        'Colleague',
        'Ex-spouse',
        'Nanny',
        'Friend',
        'Physician',
      ]),
      roles: randomBool() ? (
        <Text size="sm" truncate>
          {
            randomArrayItem([
              'Child, Household member',
              'Emergency Contact',
              'Healthcare Provider',
            ]) as any
          }
        </Text>
      ) : (
        ''
      ),
    }))

  const columns: DataGridColumns[] = [
    {
      label: 'Name',
      prop: 'name',
      defaultSort: true,
      pinned: true,
    },
    {
      label: 'Relationship',
      prop: 'relationship',
    },
    {
      label: 'Roles',
      prop: 'roles',
    },
    {
      label: 'Tags',
      prop: 'tags',
    },
  ]

  const sections: DataGridSections[] = [
    {
      label: 'All Records',
      href: '#',
      default: true,
    },
    {
      label: 'Adults',
      href: '#',
    },
    {
      label: 'Children',
      href: '#',
    },
    {
      label: 'Contacts',
      href: '#',
    },
    {
      label: 'Parents / Guardians',
      href: '#',
    },
    {
      label: 'Record Persons',
      href: '#',
    },
  ]

  const actions: DataGridActions[] = [
    {
      label: 'Request edit access',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Request data share',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Request data check',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Request callback',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Edit custom fields',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Edit relationship',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Edit roles',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Add tags',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Remove tag',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Delete record',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
  ]

  const selectedActions: DataGridSelectedActions[] = [
    {
      label: 'Edit',
      onClick: (items: any) => console.log('Selected Actions: Edit'),
    },
    {
      label: 'Tags',
      onClick: (items: any) => console.log('Selected Actions: Tags'),
      component: (
        <div>
          <Menu position="bottom-start">
            <Menu.Target>
              <Button
                variant="default"
                rightSection={<IconChevronDown size={18} />}
              >
                Tags
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Add tags</Menu.Item>
              <Menu.Item color="red">Remove tags</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      ),
    },
    {
      label: 'Options',
      onClick: (items: any) => {},
      component: (
        <div>
          <Menu>
            <Menu.Target>
              <ActionIcon variant="default" radius="xl" aria-label="Options">
                <IconDots
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Request edit access</Menu.Item>
              <Menu.Item>Request data share</Menu.Item>
              <Menu.Item>Request data check</Menu.Item>
              <Menu.Item>Request callback</Menu.Item>
              <Menu.Item>Edit relationship</Menu.Item>
              <Menu.Item>Edit roles</Menu.Item>
              <Menu.Item>Link records</Menu.Item>
              <Menu.Item>Create email list</Menu.Item>
              <Menu.Item color="red">Delete records</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      ),
    },
  ]

  return (
    <Box className={classes.Record__content}>
      <DataGrid
        data={data}
        columns={columns}
        sections={sections}
        actions={actions}
        results={data.length}
        buttons={<Button>Link Records</Button>}
        selectedActions={selectedActions}
        page={1}
      />
    </Box>
  )
}
